import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link , useLocation ,useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import ProdList from "../components/ProdList";

export default function ProductBuyInfo() {
    const { t } = useTranslation();

    let {id} = useParams();
    const lang = localStorage.getItem("language") || "ko";
    const [request] = useAxios();
    const [data, setData] = useState({});
    const [isOpen, setOpen] = useState(false);

    const fetchData = async () => {

        const response = await request.post("/app/goods/getGoodsDetailAPI", {
            nationSeCode : lang,
            goodsSn : id
        });
        if(response.data.resultCode === 200){
            console.log(response.data.result);
            setData(response.data.result);
        }            
    };
    useEffect(() => {
        fetchData();
      }, []);
    return(

        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
            <Header type="cart" pageTitle={data.goodsInfoVO && data.goodsInfoVO.goodsNm}/>
                <div className="tabArea">
                    <Link to={"/ProductDetail/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title1`)}</Link>
                    <Link to="" className="tabBtn active">{t(`Message.goods_detail_screen_tab_title2`)}</Link>
                    <Link to={"/ProductReview/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title3`)} {data.goodsReviewCnt && data.goodsReviewCnt}</Link>
                    <Link to={"/ProductQnA/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title4`)} {data.goodsInqryCnt && data.goodsInqryCnt}</Link>
                </div>
            </div>


            <div className="hdTabContWr">
                <div className="ltrcWr pb50">
                    <h3 className="title">{t(`Message.goods_info_provd_ntfc_goods_noti_info`)}</h3>
                    <ul className="ltrc">
                        {data.goodsInfoProvdNtfcMapList && data.goodsInfoProvdNtfcMapList.map((obj, index) => (
                        <li key={index}>
                            <p className="lt">{obj.codeNm}</p>
                            <div className="rc">
                                <p>
                                    {obj.cdCn1 === 'Y'?obj.codeDc: t(`Message.goods_info_provd_ntfc_goods_cn`)}
                                </p>
                            </div>
                        </li>
                        ))}                             
                    </ul>
                </div>


                <div className="ltrcWr pb50">
                    <h3 className="title">{t(`Message.goods_dlvy_dc_info_dlvy_info`)}</h3>
                    <ul className="ltrc">
                        <li>
                            <p className="lt">{t(`Message.goods_dlvy_dc_info_dlvy_method`)}</p>
                            <div className="rc">
                                <p>{data.goodsDlvyDcInfoVO?.dlvyMthSeCodeNm }</p>
                            </div>
                        </li>
                        <li>
                            <p className="lt">{t(`Message.goods_dlvy_dc_info_dlvy_co`)}</p>
                            <div className="rc">
                                <p>{data.goodsDlvyDcInfoVO?.hdryCmpnySeCodeNm }
                                <br/>배송 예정일은 주문시점이나 상품종류에 따라서 상품의 배송이 다소 지연될 수 있습니다.</p>
                            </div>
                        </li>
                        <li>
                            <p className="lt">{t(`Message.goods_dlvy_dc_info_dlvy_amt`)}</p>
                            <div className="rc">
                                <p>{data.goodsDlvyDcInfoVO?.dlvyCtSeCodeNm }</p>
                                {data.goodsDlvyDcInfoVO?.islndsBwdsDlvyAt==="Y"?(
                                    <>
                                    <p>{t(`Message.goods_dlvy_dc_info_outside_info_msg1`)}<br/>
                                        {t(`Message.goods_dlvy_dc_info_outside_jeju_amt` , {jjAreaAmount : data.goodsDlvyDcInfoVO?.jjAreaAmount.toLocaleString('ko-KR') })}<br/>
                                        {t(`Message.goods_dlvy_dc_info_outside_etc_amt` , {jjElseAreaAmount : data.goodsDlvyDcInfoVO?.jjElseAreaAmount.toLocaleString('ko-KR') })}</p>
                                    </>
                                ):null}
                            </div>
                        </li>
                        <li>
                            <p className="lt">{t(`Message.goods_dlvy_dc_info_bundle_dlvy_at`)}</p>
                            <div className="rc">
                                <p>{data.goodsDlvyDcInfoVO?.bundleDlvyAtNm }</p>
                            </div>
                        </li>
                        <li>
                            <p className="lt">{t(`Message.goods_dlvy_dc_info_dlvy_period`)}</p>
                            <div className="rc">
                                <p>{t(`Message.goods_dlvy_dc_info_outside_info_msg2`)}</p>
                                <p>{t(`Message.goods_dlvy_dc_info_outside_info_msg3`)}</p>
                            </div>
                        </li>
                    </ul>
                </div>




                <div className="ltrcWr pb50">
                    <h3 className="title">{t(`Message.goods_rtngud_exchng_dc_title`)}</h3>
                    <ul className="ltrc">
                        <li>
                            <p className="lt">{t(`Message.goods_rtngud_exchng_dc_return_cost`)}</p>
                            <div className="rc">
                                <p>￦{data.goodsRtngudExchngDcVO?.frstDlvyAmount.toLocaleString('ko-KR') }</p>
                                <p>{t(`Message.goods_rtngud_exchng_dc_free_return_cost`)}</p>
                            </div>
                        </li>
                        <li>
                            <p className="lt">{t(`Message.goods_rtngud_exchng_dc_exchange_cost`)}</p>
                            <div className="rc">
                                <p>￦7,000</p>
                                <p>{t(`Message.goods_rtngud_exchng_dc_customer_chg_reason`)}</p>
                                <p>{t(`Message.goods_rtngud_exchng_dc_outside_add_cost`)}</p>
                            </div>
                        </li>
                        <li>
                            <p className="lt">{t(`Message.goods_rtngud_exchng_dc_base_dt`)}</p>
                            <div className="rc">
                                <p>{t(`Message.goods_rtngud_exchng_dc_base_dt_announcement1`)}</p>
                                <p>{t(`Message.goods_rtngud_exchng_dc_base_dt_announcement2`)}</p>
                            </div>
                        </li>
                        <li>
                            <p className="lt">{t(`Message.goods_rtngud_exchng_dc_not_allowed_title`)}</p>
                            <div className="rc">
                                <p>{t(`Message.goods_rtngud_exchng_dc_not_allowed_info1`)}</p>
                                <p>{t(`Message.goods_rtngud_exchng_dc_not_allowed_info2`)}</p>
                                <p>{t(`Message.goods_rtngud_exchng_dc_not_allowed_info3`)}</p>
                                <p>{t(`Message.goods_rtngud_exchng_dc_not_allowed_info4`)}</p>
                                <p>{t(`Message.goods_rtngud_exchng_dc_not_allowed_info5`)}</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="bottomBtnWr">
                    <button 
                        type="button" 
                        className="btn48 cFFF orgB"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation(); 
                            setOpen(true);
                        }}>
                        {t(`Message.bottom_navigation_bar_order_btn`)}
                    </button>
                </div>

                <ProdList id={id} prodOpen={isOpen} setProdOpen={setOpen}></ProdList>
            </div>
        </div>
    );
};